import { render, staticRenderFns } from "./UbSelect.vue?vue&type=template&id=04f62a54&"
import script from "./UbSelect.vue?vue&type=script&lang=js&"
export * from "./UbSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports